import { render, staticRenderFns } from "./StudentCamera.vue?vue&type=template&id=7f7372dc&scoped=true"
import script from "./StudentCamera.vue?vue&type=script&lang=js"
export * from "./StudentCamera.vue?vue&type=script&lang=js"
import style0 from "./StudentCamera.vue?vue&type=style&index=0&id=7f7372dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7372dc",
  null
  
)

export default component.exports